import { useState } from "react";
import { useSelector } from "react-redux";

import AllDetails from "../AllDetails/AllDetails";
import TabButton from "../../../../../Components/common/TabButton/TabButton";
import AiDecision from "../AiDecision/AiDecision";
import Comments from "../../../../../Components/PagesComponents/AnalysisReports/MemoryBlock/Tabs/Comments/Comments";

const AdditionalData = ({ id }) => {
  const [active, setActive] = useState("All Details");

  const agentAnalysisData = useSelector((state) => state.integrations.agentAnalysisData);

  return (
    <div style={{ position: "relative" }}>
      <div className="button-block">
        <TabButton title="All Details" onClick={setActive} active={active} />
        <TabButton title="AI Decision and Comments" onClick={setActive} active={active} />
      </div>
      {active === "All Details" ? (
        <AllDetails
          detectionDetails={agentAnalysisData?.detection_details || { files: [], processes: [] }}
        />
      ) : active === "AI Decision and Comments" ? (
        // The agent AI decision is fetched by the page itself
        // (RequestGetAgentAIDecision), so Comments must not fetch the sandbox one
        <Comments AiDecisionComponent={AiDecision} fetchAiDecision={false} />
      ) : null}
    </div>
  );
};

export default AdditionalData;
